import React, { useState, useEffect, useRef } from 'react'
import { ConfigItem } from './ConfigItem'
import { Card, Col, Row, FormGroup, Form, Button } from 'react-bootstrap'
//import * as Icon from 'react-feather'
import { PropertiesEditModal } from './PropertiesEditModal'
import Select from 'react-select'
//import Checkbox from 'components/atoms/@vuexy/checkbox/CheckboxesVuexy'
//import Radio from 'components/atoms/@vuexy/radio/RadioVuexy'
import { Checkbox, Radio, FormControlLabel } from '@mui/material'
//import { Check } from 'react-feather'
import FeatherIcon from 'feather-icons-react'
import TinyEditorModal from './TinyEditorModal'
import {
  REPORT_IMAGE_MAX_SIZE,
  buildPdfResourceItem,
  getAttachmentFileName,
  getAttachmentFileUrl,
  getAttachmentId,
  uploadReportStaticFile,
} from './resourceUpload'
import {
  createReportDataSourceMap,
  getReportBindValue,
  getReportImageSource,
} from './reportBind.util'
import Swal from 'sweetalert2'
import ReportGroupPaginationControls from './ReportGroupPaginationControls'

const DEFAULT_BOX = {
  top: 0,
  left: 0,
  title: '',
  itemType: 'text',
  fieldName: '',
  defaultValue: '',
  value: '',
}

const unitToPx = (value, fallback = 0) => {
  if (typeof value === 'number') return value

  const match = `${value || ''}`.trim().match(/^([\d.]+)(px|cm|mm|in)?$/)
  if (!match) return fallback

  const amount = Number(match[1])
  const unit = match[2] || 'px'

  if (!Number.isFinite(amount)) return fallback
  if (unit === 'in') return amount * 96
  if (unit === 'cm') return amount * (96 / 2.54)
  if (unit === 'mm') return amount * (96 / 25.4)
  return amount
}

const renderUIOptions = [
  { label: 'Defaut', value: 'DEFAULT' },
  { label: 'Group-Level', value: 'GROUP_LEVEL' },
]

const PDF_OVERLAY_TEXT_TYPES = ['text', 'object', 'search_param', 'texteditor']

const PDF_OVERLAY_FONT_OPTIONS = [
  { label: 'TH Sarabun New', value: 'THSarabunNew' },
  { label: 'TH Sarabun', value: 'THSarabun' },
  { label: 'Prompt', value: 'Prompt' },
  { label: 'Angsana New', value: 'angsana' },
]

const PDF_OVERLAY_FONT_WEIGHT_OPTIONS = [
  { label: 'Regular (400)', value: '400' },
  { label: 'Bold (700)', value: '700' },
]

const PDF_OVERLAY_FONT_STYLE_OPTIONS = [
  { label: 'Normal', value: 'normal' },
  { label: 'Italic', value: 'italic' },
]

const PDF_OVERLAY_TEXT_ALIGN_OPTIONS = [
  { label: 'Left', value: 'left' },
  { label: 'Center', value: 'center' },
  { label: 'Right', value: 'right' },
]

const PropertiesMenu = ({
  item,
  layout,
  pdfOverlayMode = false,
  dataSourceList = [],
  onChange,
  onRemove,
  onCopy=()=>{},
  onFocus = () => {},
  onReload = () => {},
}) => {
  const {
    fieldName,
    value,
    width,
    height,
    borderTop,
    fontSize,
    lineHeight,
    fontWeight,
    fontFamily,
    fontStyle,
    textAlign,
    textColor,
    textClass,
    displayValue,
    rowHeight,
    name,
    showHeader,
    showOnFirstPage,
    showOnLastPage,
    isCurrency,
    dynamicResult,
    rowPerPage,
    pageBreakAfterRows,
    lastPageRowPerPage,
    rowsOnFirstPageOnly,
    lastPageTop,
    fillEmptyRows,
    renderUI,
    isHorizontal,
    format,
    borderStyle,
    left,
    top,
    isBackground,
    locked,
    objectFit,
  } = item

  const [showEdit, setShowEdit] = useState(false)
  const [showTinyModal, setShowTinyModal] = useState(false)
  const [showChildProp, setShowChildProp] = useState(false)
  const imageUploadInputRef = useRef(null)
  const pdfUploadInputRef = useRef(null)
  const [isUploadingPdf, setIsUploadingPdf] = useState(false)
  const dataSourceValueMap = createReportDataSourceMap(dataSourceList)
  const showPdfOverlayTextControls =
    pdfOverlayMode && PDF_OVERLAY_TEXT_TYPES.includes(item?.type)

  useEffect(() => {
    if (item && item.showTinyModal && item.showTinyModal === true) {
      setShowTinyModal(true)
    }
  }, [item])
  const updateData = (field, updateValue) => {
    let itemData = {}
    if (field === 'sourceCode') {
      itemData['showTinyModal'] = false
    }
    itemData[field] = updateValue
    if (onChange) {
      onChange(Object.assign({}, item, itemData))
    }
  }

  const onEditPropsChange = (e) => {
    if (onChange) {
      onChange(Object.assign({}, item, e))
    }
  }

  const getItemWithImageBindValue = () => {
    if (item?.type !== 'image') return item

    const bindValue = getReportBindValue(dataSourceValueMap, item?.name)
    if (typeof bindValue === 'undefined') return item

    return { ...item, value: bindValue }
  }

  const fitTextEditorToPaperWidth = () => {
    if (!onChange) return

    const left = Math.round(unitToPx(layout?.paddingLeft, 0))
    const right = Math.round(
      unitToPx(layout?.paddingRight, unitToPx(layout?.paddingLeft, 0)),
    )
    const paperWidth = Math.round(unitToPx(layout?.width, unitToPx('21cm')))
    const width = Math.max(0, paperWidth - left - right - 2)

    onChange(Object.assign({}, item, {
      left,
      width,
    }))
  }

  const onInputFocus = (field, e) => {
    if (onFocus) {
      onFocus(item)
    }
  }

  const renderInput = (title, field, value, props = {}) => {
    return (
      <div>
        <Form.Label for={field} className="text-sm-right">
          {title}
        </Form.Label>
        <Form.Control
          {...props}
          type="text"
          autoComplete="off"
          name={field}
          value={value || value === 0 ? value : ''}
          onChange={(e) => updateData(field, e.target.value)}
          onFocus={(e) => onInputFocus(field, e)}
        />
      </div>
    )
  }

  const updateBackground = (checked) => {
    const itemData = {
      isBackground: checked,
    }

    if (checked) {
      itemData.locked = item.locked !== false
      if (!item.objectFit) itemData.objectFit = 'contain'
    }

    if (onChange) {
      onChange(Object.assign({}, item, itemData))
    }
  }

  const fitBackgroundToPage = () => {
    const itemData = {
      isBackground: true,
      locked: item.locked !== false,
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      objectFit: item.objectFit || 'contain',
    }

    if (item.type === 'pdf') {
      itemData.fullPage = true
      itemData.pdfPreviewMode = 'page'
    }

    if (onChange) {
      onChange(Object.assign({}, item, itemData))
    }
  }

  const renderPositionControls = () => {
    return (
      <Row>
        <Col xs={6}>{renderInput('X', 'left', left)}</Col>
        <Col xs={6}>{renderInput('Y', 'top', top)}</Col>
      </Row>
    )
  }

  const renderBackgroundControls = () => {
    if (!['image', 'pdf'].includes(item.type)) return null

    return (
      <div>
        {renderCheckbox('ใช้เป็น Background', 'isBackground', isBackground, {
          onChange: updateBackground,
        })}
        {renderCheckbox('Lock', 'locked', locked)}
        {['image'].includes(item.type) > 0 &&
          renderSelect('Object Fit', 'objectFit', objectFit, [
            { label: 'Contain', value: 'contain' },
            { label: 'Cover', value: 'cover' },
            { label: 'Fill', value: 'fill' },
          ])}
        <Button
          variant="outline-primary"
          className="btn-block mt-1"
          onClick={fitBackgroundToPage}
        >
          <FeatherIcon size="16" icon="maximize-2" className="vx-icon mr-1" />
          Fit Background
        </Button>
      </div>
    )
  }

  const resTypeSelect = (title, field, childProp, key) => {
    const typeOptions = [
      { label: 'Barcode', value: 'barcode' },
      { label: 'QRcode', value: 'qrcode' },
    ]
    return (
      <FormGroup>
        <Form.Label
          for={field}
          className="text-sm-right"
          style={{ fontSize: 12 }}
        >
          {title}
        </Form.Label>
        <Select
          isClearable
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          menuPortalTarget={document.body}
          options={typeOptions}
          value={typeOptions.find((x) => x.value === childProp[field]) ?? null}
          onChange={(e) =>
            updateDataChildStyle(field, childProp, key, e ? e.value : null)
          }
        />
      </FormGroup>
    )
  }

  const groupLevelSelect = (title, field, childProp, key) => {
    const typeOptions = [
      { label: 'Level 1', value: 'level1' },
      { label: 'Level 2', value: 'level2' },
      { label: 'Level 3', value: 'level3' },
    ]
    if (childProp['groupDisplay'] && childProp['groupDisplay'] === true)
      return (
        <FormGroup>
          <Form.Label
            for={field}
            className="text-sm-right"
            style={{ fontSize: 12 }}
          >
            {title}
          </Form.Label>
          <Select
            isClearable
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPortalTarget={document.body}
            options={typeOptions}
            value={
              typeOptions.find((x) => x.value === childProp[field]) ?? null
            }
            onChange={(e) =>
              updateDataChildStyle(field, childProp, key, e ? e.value : null)
            }
          />
        </FormGroup>
      )
  }

  const inputChildStyle = (title, field, childProp, key) => {
    return (
      <div>
        <Form.Label
          for={field}
          className="text-sm-right"
          style={{ fontSize: 12 }}
        >
          {title}
        </Form.Label>
        <Form.Control
          type="text"
          autoComplete="off"
          name={field}
          value={childProp[field]}
          onChange={(e) =>
            updateDataChildStyle(field, childProp, key, e.target.value)
          }
        />
      </div>
    )
  }

  const checkboxChildStyle = (title, field, childProp, key) => {
    return (
      <div className="col p-0">
        <FormControlLabel
          control={
            <Checkbox
              size="small" // Use 'small' instead of 'sm'
              color="primary"
              checked={childProp[field]}
              onChange={(e) =>
                updateDataChildStyle(field, childProp, key, e.target.checked)
              }
            />
          }
          label={title}
        />
      </div>
    )
  }

  const updateDataChildStyle = (field, childProp, key, updateValue = null) => {
    if (updateValue !== null && typeof updateValue !== 'undefined') {
      childProp[field] = updateValue
    } else {
      childProp[field] = ''
    }
    if (field === 'groupDisplay') {
      childProp['groupLevel'] = 'level1'
    }

    item.fieldVariable.props[key] = childProp

    if (onChange) {
      onChange(item)
    }
  }

  const renderDataValue = () => {
    if (item.type === 'text') {
      return (
        <FormGroup row>
          <Form.Label for="value" className="text-sm-right">
            Data Value
          </Form.Label>
          <Form.Control
            type="text"
            name="fieldName"
            autoComplete="off"
            value={fieldName}
            onChange={(e) => updateData('fieldName', e.target.value)}
          />
        </FormGroup>
      )
    } else if (item.type === 'image') {
      const imageItem = getItemWithImageBindValue()
      const imageSource = getReportImageSource(imageItem)
      let { opacity } = item
      const previewObjectFit = objectFit || 'contain'
      return (
        <div>
          <input
            ref={imageUploadInputRef}
            type="file"
            accept="image/jpeg,image/png,.jpg,.jpeg,.png"
            className="d-none"
            onChange={handleImageFileChange}
          />
          {renderInput('Opacity', 'opacity', opacity)}
          <FormGroup row>
            <Form.Label for="value" className="text-sm-right">
              Preview
            </Form.Label>
          </FormGroup>

          <div
            className="mb-1"
            style={{
              width: '100%',
              height: isBackground ? 300 : 180,
              border: '1px solid #d9dee3',
              borderRadius: 4,
              background: '#f8fafc',
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 6,
              boxSizing: 'border-box',
            }}
          >
            {imageSource ? (
              <img
                src={imageSource}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: previewObjectFit,
                  opacity: opacity || 1,
                  background: '#ffffff',
                }}
              />
            ) : (
              <div className="text-muted" style={{ fontSize: 12 }}>
                No image preview
              </div>
            )}
          </div>
          <Button
            outline
            color="secondary"
            className="w-100 mt-1"
            onClick={handleImageUploadClick}
          >
            <FeatherIcon size="16" icon="upload" className="vx-icon" />{' '}
            {imageSource ? 'อัปโหลดรูปใหม่' : 'อัปโหลดรูป'}
          </Button>
        </div>
      )
    } else if (item.type === 'date') {
      return <div>{renderInput('Format', 'format', item.format)}</div>
    } else if (item.type === 'pdf') {
      const attachmentId = getAttachmentId(item) || getAttachmentId(item?.pdf)
      const fileName =
        item?.data?.name ||
        (attachmentId ? getAttachmentFileName(item?.pdf, item?.value || '') : '')
      const pdfUrl = item?.previewUrl || getAttachmentFileUrl(attachmentId)
      return (
        <div>
          <input
            ref={pdfUploadInputRef}
            type="file"
            accept="application/pdf,.pdf"
            className="d-none"
            onChange={handlePdfFileChange}
          />
          {renderInput('Attachment ID', 'attachmentId', attachmentId, {
            disabled: true,
          })}
          {fileName && (
            <div className="mt-1" style={{ fontSize: 12 }}>
              {fileName}
            </div>
          )}
          <Button
            outline
            color="primary"
            className="w-100 mt-1"
            disabled={!pdfUrl}
            onClick={() =>
              window.open(
                pdfUrl,
                '_blank',
              )
            }
          >
            <FeatherIcon size="16" icon="file" className="vx-icon" /> Preview PDF
          </Button>
          <Button
            outline
            color="secondary"
            className="w-100 mt-1"
            disabled={isUploadingPdf}
            onClick={handlePdfUploadClick}
          >
            <FeatherIcon size="16" icon="upload" className="vx-icon" />{' '}
            {isUploadingPdf
              ? 'กำลังอัปโหลด...'
              : attachmentId
                ? 'อัปโหลด PDF ใหม่'
                : 'อัปโหลด PDF'}
          </Button>
        </div>
      )
    } else if (item.type === 'texteditor') {
      return (
        <FormGroup row className="mt-1">
          <Button
            outline
            color="primary"
            className="w-100"
            title="แก้ไขเนื้อหา Style และการแบ่งหน้าของรายงาน"
            onClick={() => setShowTinyModal(true)}
          >
            <FeatherIcon
              size="16"
              icon="edit-3"
              className="vx-icon "
            />{' '}
            แก้เนื้อหา / Style / แบ่งหน้า
          </Button>
        </FormGroup>
      )
    } else if (item.type === 'check_box') {
      let { size, title, fontSize, fontWeight } = item
      return (
        <div>
          {renderInput('Size', 'size', size)}
          {renderInput('Title', 'title', title)}
          {renderInput('Font Size', 'fontSize', fontSize)}
          {renderInput('Font Weight', 'fontWeight', fontWeight)}
        </div>
      )
    } else if (item.type === 'get_api') {
      let { endpoint, fontSize, lineHeight, fontWeight, textAlign, textClass } = item
      return (
        <div>
          {renderInput('Endpoint', 'endpoint', endpoint)}
          {renderInput('Font Size', 'fontSize', fontSize)}
          {renderInput('Line Height', 'lineHeight', lineHeight, {
            placeholder: 'เช่น 1.4 หรือ 26px',
          })}
          {renderInput('Font Weight', 'fontWeight', fontWeight)}
          {renderInput('Text Align', 'textAlign', textAlign)}
          {renderInput('Text Class', 'textClass', textClass)}
        </div>
      )
    } else if (item.type === 'vital_sign') {
      let { dataSourceId } = item
      return <div>{renderDataSourceChoice('dataSourceId', dataSourceId)}</div>
    } else if (item.type === 'advance_table') {
      let { fieldVariable } = item

      return (
        <div>
          <FormGroup row className="col">
            <FormControlLabel
              control={
                <Checkbox
                  size="small" // Use 'small' instead of 'sm'
                  color="primary"
                  checked={showChildProp}
                  onChange={(e) => setShowChildProp(e.target.checked)}
                />
              }
              label={'Child Properties'}
            />
          </FormGroup>
          {showChildProp && (
            <div>
              {Object.keys(fieldVariable.props).map((key) => {
                let chProp = fieldVariable.props[key]
                return (
                  <div
                    className=" mb-50 p-10 m-b-15"
                    style={{ border: '1px dashed gray' }}
                  >
                    <div
                      className="font-weight-bold"
                      style={{
                        borderLeft: '5px solid #7367f0',
                        paddingLeft: 5,
                      }}
                    >
                      {chProp.title}
                    </div>
                    <div className="pl-50">
                      {resTypeSelect('Resource Type', 'resType', chProp, key)}
                      {checkboxChildStyle(
                        'Currency?',
                        'isCurrency',
                        chProp,
                        key,
                      )}
                      {checkboxChildStyle(
                        'Group Total Style ',
                        'rowTypeGroupTotalStyle',
                        chProp,
                        key,
                      )}                      
                      {checkboxChildStyle(
                        'แสดงเป็น Group',
                        'groupDisplay',
                        chProp,
                        key,
                      )}
                      {groupLevelSelect(
                        'Group Level',
                        'groupLevel',
                        chProp,
                        key,
                      )}
                      {inputChildStyle('Width', 'width', chProp, key)}
                      {inputChildStyle('Height', 'height', chProp, key)}
                      {inputChildStyle('Font Size', 'fontSize', chProp, key)}
                      {inputChildStyle(
                        'Font Weight',
                        'fontWeight',
                        chProp,
                        key,
                      )}
                      {inputChildStyle('Text Align', 'textAlign', chProp, key)}
                      {inputChildStyle('Text Class', 'textClass', chProp, key)}
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      )
    } else {
      return ''
    }
  }

  const renderDataSourceChoice = (field, dataSourceId) => {
    return (
      <FormGroup row>
        <div>{'Datasource Props'}</div>
        <div style={{ width: '100%' }}>
          <Select
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPortalTarget={document.body}
            isClearable={true}
            // maxMenuHeight={options.length > 0 ? 48 * options.length : 48}
            options={dataSourceList.map((item) => ({
              label: item.dataSourceName,
              value: item.dataSourceId,
            }))}
            value={
              dataSourceList
                .map((item) => ({
                  label: item.dataSourceName,
                  value: item.dataSourceId,
                }))
                .find((option) => option.value === dataSourceId) || null
            }
            onChange={async (e) => updateData(field, e ? e?.value : null)}
            // components={{ Option: IconOption, SingleValue: CustomSingleValue }}
          ></Select>
        </div>
      </FormGroup>
    )
  }

  const renderSelect = (
    title,
    field,
    value,
    options = [],
    defaultIndex = 0,
  ) => {
    return (
      <FormGroup row>
        <div>{title}</div>
        <div style={{ width: '100%' }}>
          <Select
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPortalTarget={document.body}
            isClearable={true}
            // maxMenuHeight={options.length > 0 ? 48 * options.length : 48}
            options={options}
            value={
              options
                .map((item) => ({
                  label: item.label,
                  value: item.value,
                }))
                .find((option) => option.value === value) ||
              (defaultIndex >= 0 && options.length > 0
                ? options[defaultIndex]
                : null)
            }
            onChange={async (e) => updateData(field, e ? e?.value : null)}
            // components={{ Option: IconOption, SingleValue: CustomSingleValue }}
          ></Select>
        </div>
      </FormGroup>
    )
  }

  const renderColorInput = (title, field, value) => {
    const normalizedValue = /^#[0-9a-f]{6}$/i.test(value || '')
      ? value
      : '#000000'

    return (
      <FormGroup row>
        <div>{title}</div>
        <div className="d-flex" style={{ width: '100%', gap: 8 }}>
          <Form.Control
            type="color"
            name={field}
            value={normalizedValue}
            title="เลือกสีข้อความสำหรับ PDF Overlay"
            style={{ flex: '0 0 48px', padding: 3 }}
            onChange={(e) => updateData(field, e.target.value)}
            onFocus={(e) => onInputFocus(field, e)}
          />
          <Form.Control
            type="text"
            autoComplete="off"
            name={`${field}Hex`}
            value={value || ''}
            placeholder="#000000"
            onChange={(e) => updateData(field, e.target.value)}
            onFocus={(e) => onInputFocus(field, e)}
          />
        </div>
      </FormGroup>
    )
  }

  const renderCheckbox = (title, field, value, props = {}) => {
    return (
      <FormGroup row className="col pr-0">
        <FormControlLabel
          control={
            <Checkbox
              size="small" // Use 'small' instead of 'sm'
              color="primary"
              checked={Boolean(value)}
              onChange={(e) => {
                if (props.onChange) {
                  props.onChange(e.target.checked)
                  return
                }
                updateData(field, !item[field])
              }}
            />
          }
          label={title}
        />
      </FormGroup>
    )
  }

  const renderChoice = (title, field, value) => {
    return (
      <div>
        {title}
        <Radio
          color="primary"
          label={'แนวนอน'}
          icon={<FeatherIcon size="12" icon="check" className="vx-icon" />}
          value={true}
          checked={value === true || value === undefined}
          onChange={(e) => updateData(field, e.target.value === 'true')}
        />
        <Radio
          color="primary"
          label={'แนวตั้ง'}
          icon={<FeatherIcon size="12" icon="check" className="vx-icon" />}
          value={false}
          checked={value === false}
          onChange={(e) => updateData(field, e.target.value === 'true')}
        />
      </div>
    )
  }

  const renderButton = () => {
    return (
      <div className="text-right mt-75">
        {item.type === 'table' && (
          <FeatherIcon
            size="16"
            icon="edit"
            className="vx-icon "
            onClick={() => setShowEdit(true)}
          />
        )}{' '}
        {['choice'].includes(item.type) > 0 && (
          <FeatherIcon
            size="16"
            icon="refresh-cw"
            className="vx-icon "
            onClick={() => onReload(item)}
          />
        )}
        <FeatherIcon
          size="16"
          icon="copy"
          className="vx-icon text-c-blue m-r-10"
          onClick={() => onCopy(item)}
        />
        <FeatherIcon
          size="16"
          icon="trash"
          className="vx-icon text-c-red"
          onClick={() => onRemove(item)}
        />
      </div>
    )
  }

  const updateTinyEditorData = (sourceCode, styleData) => {
    if (onChange) {
      onChange(Object.assign({}, item, {
        sourceCode,
        styleData,
        showTinyModal: false,
      }))
    }
  }

  const handleImageUploadClick = () => {
    imageUploadInputRef.current?.click()
  }

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (error) => reject(error)
    })

  const handleImageFileChange = async (event) => {
    const file = event.target.files?.[0]
    event.target.value = ''
    if (!file) return

    const isImageFile =
      ['image/jpeg', 'image/png'].includes(file.type) ||
      /\.(jpg|jpeg|png)$/i.test(file.name)

    if (!isImageFile) {
      Swal.fire('Image', 'รองรับเฉพาะไฟล์ JPG หรือ PNG', 'warning')
      return
    }

    if (file.size > REPORT_IMAGE_MAX_SIZE) {
      Swal.fire('Image', 'รูปภาพต้องมีขนาดไม่เกิน 2 MB', 'warning')
      return
    }

    try {
      const previewFile = Object.assign(file, {
        preview: URL.createObjectURL(file),
      })
      const itemWithoutOldFile = { ...item }
      delete itemWithoutOldFile.data
      delete itemWithoutOldFile.image
      delete itemWithoutOldFile.previewUrl
      delete itemWithoutOldFile.pdf
      delete itemWithoutOldFile.attachmentId

      const image = await toBase64(file)

      if (onChange) {
        onChange({
          ...itemWithoutOldFile,
          data: previewFile,
          image,
          value: file.name,
        })
      }
    } catch (error) {
      Swal.fire(
        'อัปโหลดรูปไม่สำเร็จ',
        error?.message || 'ไม่สามารถอ่านไฟล์รูปภาพได้',
        'error',
      )
    }
  }

  const handlePdfUploadClick = () => {
    pdfUploadInputRef.current?.click()
  }

  const handlePdfFileChange = async (event) => {
    const file = event.target.files?.[0]
    event.target.value = ''
    if (!file) return

    if (file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf')) {
      Swal.fire('PDF', 'รองรับเฉพาะไฟล์ PDF', 'warning')
      return
    }

    setIsUploadingPdf(true)
    try {
      const attachment = await uploadReportStaticFile(file, 'report.pdf')
      if (onChange) {
        onChange(buildPdfResourceItem(item, attachment, file.name))
      }
    } catch (error) {
      Swal.fire(
        'อัปโหลด PDF ไม่สำเร็จ',
        error?.response?.data?.message ||
          error?.message ||
          'ไม่สามารถอัปโหลดไฟล์ PDF ได้',
        'error',
      )
    } finally {
      setIsUploadingPdf(false)
    }
  }

  if (item.id && item.type === 'report_resource') {
    return (
      <div className="p-1">
        {renderInput('Type', 'type', item.type, { disabled: true })}
        {renderInput('Report code', 'resourceCode', item.resourceCode, {
          disabled: true,
        })}
        {renderPositionControls()}
        {renderCheckbox(
          'แสดงเหมือนกันทุกหน้า',
          'showOnEveryPage',
          item.showOnEveryPage,
        )}
        <small className="d-block text-muted mt-2">
          Resource นี้แก้ไขและปรับขนาดจากรายงานปลายทางไม่ได้
          หากต้องการแก้ไขให้แก้ที่ Report ต้นทาง
        </small>
        <div className="text-right mt-75">
          <FeatherIcon
            size="16"
            icon="trash"
            className="vx-icon text-c-red"
            title="ลบ Report Resource ออกจากรายงาน"
            onClick={() => onRemove(item)}
          />
        </div>
      </div>
    )
  }

  if (item.id) {
    return (
      <div className="p-1">
        {renderInput('Type', 'type', item.type, { disabled: true })}
        {renderInput('Bind Value', 'name', name)}
        {['text'].includes(item.type) > 0 &&
          renderInput('Value', 'value', value)}
        {['textformat'].includes(item.type) > 0 &&
          renderInput('Format', 'format', format)}          
        {renderCheckbox('แสดงผลหน้าแรก', 'showOnFirstPage', showOnFirstPage)}
        {renderCheckbox('แสดงผลหน้าสุดท้าย', 'showOnLastPage', showOnLastPage)}
        {showOnLastPage &&
          renderInput('Last Page Top', 'lastPageTop', lastPageTop)}
        {renderPositionControls()}
        {renderBackgroundControls()}
        {renderInput('Width', 'width', width)}
        {renderInput('Height', 'height', height)}
        {!pdfOverlayMode && item.type === 'texteditor' && (
          <div className="mt-2 mb-2">
            <Form.Label htmlFor="report-flow-mode">จัดหน้าตามเนื้อหา</Form.Label>
            <Select inputId="report-flow-mode"
              options={[{ value: '', label: 'ตำแหน่งคงที่ (เดิม)' }, { value: 'split', label: 'ขยายและต่อหน้า' }, { value: 'keep', label: 'ย้ายทั้งกลุ่มเมื่อพื้นที่ไม่พอ' }]}
              value={{ value: item.flowMode || '', label: { split: 'ขยายและต่อหน้า', keep: 'ย้ายทั้งกลุ่มเมื่อพื้นที่ไม่พอ' }[item.flowMode] || 'ตำแหน่งคงที่ (เดิม)' }}
              onChange={(option) => updateData('flowMode', option?.value || '')} />
            {item.flowMode === 'split' && renderInput('หัวข้อ (เติม “ต่อ” ในหน้าถัดไป)', 'flowTitle', item.flowTitle)}
            <small className="text-muted">เรียงกล่องตามตำแหน่งบนลงล่าง วัดข้อความจริงก่อนพิมพ์ ใช้กับแบบฟอร์มหน้าเดียวและกล่อง Text Editor เท่านั้น</small>
          </div>
        )}
        {item.type === 'texteditor' && (
          <Button
            variant="outline-primary"
            className="btn-block mt-1"
            title="ปรับความกว้าง Text Editor ให้พอดีกับพื้นที่กระดาษ"
            onClick={fitTextEditorToPaperWidth}
          >
            <FeatherIcon size="16" icon="maximize-2" className="vx-icon mr-1" />
            Fit Width เส้นปะ
          </Button>
        )}
        {['hline'].includes(item.type) > 0 &&
          renderInput('Border Style', 'borderStyle', borderStyle)}        
        {['vline'].includes(item.type) > 0 &&
          renderInput('Border Style', 'borderStyle', borderStyle)}        
        {['advance_table'].includes(item.type) > 0 &&
          renderInput('Row Height', 'rowHeight', rowHeight)}
        {['advance_table'].includes(item.type) > 0 &&
          renderCheckbox('Show Header', 'showHeader', showHeader)}
        {['advance_table', 'texteditor'].includes(item.type) > 0 &&
          !(item.type === 'advance_table' && renderUI === 'GROUP_LEVEL') &&
          renderInput('Row Per Page', 'rowPerPage', rowPerPage)}
        {['advance_table', 'texteditor'].includes(item.type) > 0 &&
          renderInput(
            'Page Break After Rows',
            'pageBreakAfterRows',
            pageBreakAfterRows,
          )}
        {['advance_table', 'texteditor'].includes(item.type) > 0 &&
          renderInput(
            'Last Page Row Per Page',
            'lastPageRowPerPage',
            lastPageRowPerPage,
          )}
        {['advance_table', 'texteditor'].includes(item.type) > 0 &&
          renderCheckbox(
            'แสดงแถวทั้งหมดเฉพาะหน้าแรก',
            'rowsOnFirstPageOnly',
            rowsOnFirstPageOnly,
          )}
        {item.type === 'texteditor' &&
          renderCheckbox(
            'เติมแถวว่างให้ครบ Row Per Page',
            'fillEmptyRows',
            fillEmptyRows,
          )}
        {['advance_table'].includes(item.type) > 0 &&
          renderSelect('Render UI', 'renderUI', renderUI, renderUIOptions)}
        <ReportGroupPaginationControls
          item={item}
          dataSourceList={dataSourceList}
          onChange={onChange}
        />
        {showPdfOverlayTextControls &&
          renderSelect(
            'Font Family',
            'fontFamily',
            fontFamily || layout?.fontFamily || 'THSarabunNew',
            PDF_OVERLAY_FONT_OPTIONS,
          )}
        {showPdfOverlayTextControls &&
          renderInput('Font Size', 'fontSize', fontSize, {
            placeholder: 'เช่น 14px',
          })}
        {showPdfOverlayTextControls &&
          renderInput('Line Height', 'lineHeight', lineHeight, {
            placeholder: 'เช่น 1.4 หรือ 26px',
          })}
        {showPdfOverlayTextControls &&
          renderSelect(
            'Font Weight',
            'fontWeight',
            `${fontWeight || 400}`,
            PDF_OVERLAY_FONT_WEIGHT_OPTIONS,
          )}
        {showPdfOverlayTextControls &&
          renderSelect(
            'Font Style',
            'fontStyle',
            fontStyle || 'normal',
            PDF_OVERLAY_FONT_STYLE_OPTIONS,
          )}
        {showPdfOverlayTextControls &&
          renderSelect(
            'Text Align',
            'textAlign',
            textAlign || 'left',
            PDF_OVERLAY_TEXT_ALIGN_OPTIONS,
          )}
        {showPdfOverlayTextControls &&
          renderColorInput('Text Color', 'textColor', textColor)}
        {!showPdfOverlayTextControls &&
          ['text', 'object', 'advance_table'].includes(item.type) > 0 &&
          renderInput('Font Size', 'fontSize', fontSize)}
        {!showPdfOverlayTextControls &&
          ['text', 'object', 'advance_table'].includes(item.type) > 0 &&
          renderInput('Line Height', 'lineHeight', lineHeight, {
            placeholder: 'เช่น 1.4 หรือ 26px',
          })}
        {!showPdfOverlayTextControls &&
          ['text', 'object', 'advance_table'].includes(item.type) > 0 &&
          renderInput('Font Weight', 'fontWeight', fontWeight)}
        {!showPdfOverlayTextControls &&
          ['text', 'object', 'advance_table'].includes(item.type) > 0 &&
          renderInput('Text Align', 'textAlign', textAlign)}
        {['text', 'object', 'advance_table'].includes(item.type) > 0 &&
          renderInput('Text Class', 'textClass', textClass)}
        {['barcode'].includes(item.type) > 0 &&
          renderCheckbox('Display Value', 'displayValue', displayValue)}
        {['text', 'object'].includes(item.type) > 0 &&
          renderCheckbox('Currency?', 'isCurrency', isCurrency)}
        {item.type == 'advance_table' &&
          renderInput('Top Border', 'borderTop', borderTop)}
        {item.type == 'choice' &&
          renderChoice('แสดงผลในแนว', 'isHorizontal', isHorizontal)}
        {renderDataValue()}
        {renderButton()}

        {showEdit && (
          <PropertiesEditModal
            show={showEdit}
            item={item}
            onHide={() => setShowEdit(false)}
            onChange={(e) => onEditPropsChange(e)}
          />
        )}

        <TinyEditorModal
          showModal={showTinyModal}
          setShowModal={setShowTinyModal}
          sourceCode={item.sourceCode}
          styleData={item.styleData}
          layout={layout}
          dataSourceList={dataSourceList}
          onSave={updateTinyEditorData}
        />
      </div>
    )
  } else {
    return null
  }
}

export default PropertiesMenu
